import { Pipe, PipeTransform } from '@angular/core';
import { PhoneFormatModel } from '@data-access';

const INTERNATIONAL_PHONE_LENGTH = 13;
const MIN_PHONE_LENGTH_FOR_CODE = 9;
const DEFAULT_COUNTRY_CODE = '+380';
const MASK_DIGIT = '0';

@Pipe({
  name: 'fr8botPhone',
  pure: false,
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(model?: PhoneFormatModel, addCode: boolean = true): string {
    if (!model?.value?.length) return '';
    const l = INTERNATIONAL_PHONE_LENGTH - model?.value?.length ? model?.value.length : 0;
    const code =
      model && model?.code
        ? model.code
        : model?.value.length < MIN_PHONE_LENGTH_FOR_CODE
          ? ''
          : DEFAULT_COUNTRY_CODE.substring(0, DEFAULT_COUNTRY_CODE.length - l);
    const mask =
      model && model?.mask
        ? model.mask
        : model?.value.startsWith('+')
          ? '00 000 00 00'
          : '000 000 00 00';

    const num = model?.value.startsWith('+')
      ? model?.value.substring(
          model?.code?.length ? model.code.length : DEFAULT_COUNTRY_CODE.length,
        )
      : model?.value;
    let index: number = 0;
    let res = addCode ? code + ' ' : '';
    for (let i = 0; i < mask.length; i++) {
      if (mask[i] === MASK_DIGIT) {
        if (num[index]) {
          res += num[index];
          index++;
        } else {
          break;
        }
      } else {
        res += mask[i];
      }
    }
    return res;
  }
}
